import Vue from 'vue'
import { _AUTH__SET_EMAIL } from '@/store/mutations'

interface Computed {
  authEmail: string
}

interface Methods {
  resetAuthEmail: () => void
}

export default Vue.extend<{}, Methods, Computed, {}>({
  computed: {
    authEmail: {
      get(): string {
        return this.$store.state.auth.email
      },
      set(_value): void {
        this.$store.commit(_AUTH__SET_EMAIL, _value)
      },
    },
  },
  methods: {
    resetAuthEmail() {
      this.authEmail = ''
    },
  },
})
